<template>
	<div>
		<div class="content mt-5" id="row-slot">
			<p>You can customize the whole row through the <code>row</code> scoped slot:</p>
			<pre v-highlightjs class="box pa-0"><code class="html" v-pre>&lt;ui-table :items=&quot;items&quot; bordered&gt;
	&lt;ui-table-column header=&quot;Item key&quot; fit/&gt;
	&lt;ui-table-column header=&quot;Item&quot;/&gt;
	&lt;template #row=&quot;{ item, itemKey }&quot;&gt;
		&lt;tr&gt;
			&lt;th rowspan=&quot;3&quot;&gt;{{itemKey}}&lt;/th&gt;
			&lt;td&gt;#ID: {{item.id}}&lt;/td&gt;
		&lt;/tr&gt;
		&lt;tr&gt;
			&lt;td&gt;Title: {{item.title}}&lt;/td&gt;
		&lt;/tr&gt;
		&lt;tr&gt;
			&lt;td&gt;Body: {{item.body}}&lt;/td&gt;
		&lt;/tr&gt;
	&lt;/template&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<ui-table :items="items" container-class="box" bordered>
			<ui-table-column header="Item key" fit/>
			<ui-table-column header="Item"/>
			<template #row="{ item, itemKey }">
				<tr>
					<th rowspan="3">{{itemKey}}</th>
					<td>#ID: {{item.id}}</td>
				</tr>
				<tr>
					<td>Title: {{item.title}}</td>
				</tr>
				<tr>
					<td>Body: {{item.body}}</td>
				</tr>
			</template>
		</ui-table>
	</div>
</template>

<script>

    export default {
        name: "row-slot",
		props: {
            items: Array
		}
    }
</script>